<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white error-404-card radius-7"
  >
    <div class="card-body letter-spacing style-terms-area legal-document">
      <h1>Política de Privacidade</h1>

      <p class="document-date"><strong>Última atualização: 20 de julho de 2026.</strong></p>

      <p class="text-terms">
        Esta Política de Privacidade explica como a Sanvault, responsável pela
        plataforma Centrallize ("Centrallize", "nós" ou "plataforma"), trata dados
        pessoais ao oferecer seu sistema de gestão para salões de beleza,
        barbearias e outros estabelecimentos do setor de beleza e bem-estar.
      </p>

      <p class="text-terms">
        O Centrallize permite gerenciar clientes, profissionais, agenda, serviços,
        produtos, vendas, pagamentos, desempenho, comunicações e integrações com
        serviços de terceiros, incluindo o WhatsApp Business. Ao utilizar a
        plataforma, o estabelecimento contratante também deve disponibilizar aos
        seus próprios clientes informações adequadas sobre como utiliza os dados
        pessoais deles.
      </p>

      <h4>1. Papéis no tratamento de dados</h4>
      <p class="text-terms">
        Para os dados de cadastro do estabelecimento, usuários da conta,
        assinatura, cobrança, suporte e segurança da plataforma, o Centrallize atua
        como controlador, pois define as finalidades e os meios essenciais desse
        tratamento.
      </p>
      <p class="text-terms">
        Para os dados de clientes, profissionais e demais pessoas cadastradas pelo
        estabelecimento, o próprio estabelecimento é, em regra, o controlador, e o
        Centrallize atua como operador, tratando os dados conforme as instruções do
        estabelecimento e para executar as funcionalidades contratadas. Solicitações
        relacionadas a esses dados devem ser dirigidas inicialmente ao
        estabelecimento responsável pelo cadastro.
      </p>

      <h4>2. Dados pessoais que podemos tratar</h4>
      <ul class="text-terms">
        <li>
          <strong>Cadastro e conta:</strong> nome, e-mail, telefone, credenciais de
          acesso, função, permissões e vínculo com o estabelecimento.
        </li>
        <li>
          <strong>Dados do estabelecimento:</strong> nome empresarial ou nome
          fantasia, CPF ou CNPJ, endereço, contatos, informações fiscais e dados
          necessários à contratação.
        </li>
        <li>
          <strong>Gestão do salão:</strong> cadastros de clientes e profissionais,
          histórico de agendamentos, serviços, produtos, vendas, pagamentos,
          comissões, metas, preferências e observações inseridas pelos usuários.
        </li>
        <li>
          <strong>WhatsApp Business:</strong> número de telefone, identificadores da
          conta e do número comercial, conteúdo das mensagens, anexos, datas,
          horários, status de envio e entrega e demais metadados necessários para
          exibir e administrar as conversas autorizadas pelo estabelecimento.
        </li>
        <li>
          <strong>Assinatura e cobrança:</strong> plano, situação da assinatura,
          valores, histórico e identificadores de transações. Quando o pagamento é
          realizado diretamente por um provedor, os dados completos do cartão são
          tratados por esse provedor, conforme suas próprias políticas.
        </li>
        <li>
          <strong>Dados técnicos:</strong> endereço IP, navegador, dispositivo,
          registros de acesso, eventos de segurança, cookies e informações sobre o
          uso das funcionalidades.
        </li>
        <li>
          <strong>Atendimento:</strong> mensagens, arquivos e outras informações
          fornecidas em solicitações de suporte.
        </li>
      </ul>

      <h4>3. Como utilizamos os dados</h4>
      <ul class="text-terms">
        <li>criar e administrar contas e controlar permissões de acesso;</li>
        <li>
          disponibilizar agenda, cadastro de clientes, gestão de equipe, vendas,
          estoque, financeiro, relatórios e demais recursos do sistema;
        </li>
        <li>
          integrar e sincronizar conversas autorizadas do WhatsApp Business, enviar
          confirmações, lembretes e permitir atendimento ao cliente;
        </li>
        <li>processar assinaturas, cobranças e documentos relacionados;</li>
        <li>prestar suporte e enviar comunicações operacionais;</li>
        <li>
          prevenir fraudes, abusos e acessos não autorizados, investigar incidentes
          e manter a segurança da plataforma;
        </li>
        <li>
          gerar métricas, corrigir falhas e aprimorar funcionalidades, utilizando
          dados agregados ou anonimizados sempre que possível;
        </li>
        <li>
          cumprir obrigações legais e regulatórias e exercer direitos em processos
          administrativos, judiciais ou arbitrais.
        </li>
      </ul>

      <h4>4. Bases legais</h4>
      <p class="text-terms">
        O tratamento poderá se basear na execução de contrato e de procedimentos
        preliminares, cumprimento de obrigação legal ou regulatória, exercício
        regular de direitos, legítimo interesse, proteção contra fraude e, quando
        aplicável, consentimento. O estabelecimento é responsável por definir e
        documentar a base legal adequada para os dados de seus clientes e para as
        comunicações que realiza por meio da plataforma.
      </p>

      <h4>5. Compartilhamento e operadores de serviço</h4>
      <p class="text-terms">
        Podemos compartilhar somente os dados necessários com fornecedores que
        apoiam a operação do Centrallize, como serviços de hospedagem e nuvem,
        armazenamento, banco de dados, comunicação em tempo real, envio de e-mails,
        suporte, monitoramento técnico e processamento de pagamentos. Esses
        fornecedores devem tratar os dados para as finalidades contratadas e de
        acordo com obrigações de segurança e confidencialidade.
      </p>
      <p class="text-terms">
        Quando o estabelecimento ativa uma integração, dados também podem ser
        compartilhados com o respectivo provedor. Na integração com o WhatsApp
        Business, isso inclui empresas do grupo Meta. Em pagamentos, pode incluir
        processadores como Stripe ou Mercado Pago, conforme a opção utilizada. Cada
        serviço de terceiro possui termos e políticas de privacidade próprios.
      </p>
      <p class="text-terms">
        Também poderemos compartilhar informações para cumprir a lei, ordem judicial
        ou requisição válida de autoridade pública, proteger direitos e segurança ou
        viabilizar uma reorganização societária, sempre observando a legislação
        aplicável.
      </p>

      <h4>6. Transferências internacionais</h4>
      <p class="text-terms">
        Alguns fornecedores podem armazenar ou processar dados em outros países.
        Nessas situações, adotamos mecanismos e salvaguardas compatíveis com a Lei
        Geral de Proteção de Dados Pessoais (LGPD), conforme aplicável, e exigimos
        proteção adequada dos dados tratados em nosso nome.
      </p>

      <h4>7. Armazenamento e retenção</h4>
      <p class="text-terms">
        Mantemos os dados pelo período necessário para prestar os serviços, cumprir
        as finalidades informadas e atender obrigações legais, fiscais, contábeis,
        contratuais e de segurança. Após o encerramento da conta, os dados poderão
        permanecer temporariamente em cópias de segurança ou ser conservados quando
        houver fundamento legal, sendo posteriormente eliminados ou anonimizados.
      </p>
      <p class="text-terms">
        Como controlador dos dados de seus clientes, o estabelecimento é responsável
        por definir os prazos de retenção desses registros e solicitar sua exclusão
        quando cabível.
      </p>

      <h4>8. Segurança da informação</h4>
      <p class="text-terms">
        Adotamos medidas técnicas e administrativas razoáveis para proteger os dados,
        incluindo controles de acesso, segregação por conta, comunicação protegida,
        registros de segurança, rotinas de backup e proteção de credenciais sensíveis
        quando aplicável. Nenhum sistema é totalmente imune a riscos; por isso, os
        usuários também devem proteger suas senhas, limitar acessos e comunicar
        imediatamente qualquer suspeita de uso indevido.
      </p>

      <h4>9. Direitos dos titulares</h4>
      <p class="text-terms">
        Nos termos da LGPD, o titular pode solicitar, conforme aplicável: confirmação
        e acesso; correção; anonimização, bloqueio ou eliminação; portabilidade;
        informações sobre compartilhamentos; revisão de decisões automatizadas;
        revogação do consentimento; e oposição a tratamentos irregulares. Poderemos
        solicitar informações para confirmar a identidade do requerente.
      </p>
      <p class="text-terms">
        Se os dados foram cadastrados por um salão ou outro estabelecimento cliente,
        a solicitação deve ser feita primeiro a esse estabelecimento. O Centrallize
        prestará o apoio tecnicamente possível ao controlador. Para dados controlados
        diretamente pelo Centrallize, escreva para
        <a href="mailto:contato@sanvault.com.br">contato@sanvault.com.br</a>.
      </p>

      <h4>10. Cookies e tecnologias semelhantes</h4>
      <p class="text-terms">
        Utilizamos cookies e armazenamento local necessários para autenticação,
        segurança, preferências e funcionamento do sistema. Também poderemos utilizar
        tecnologias de medição para compreender o desempenho da plataforma. O bloqueio
        de cookies essenciais pode impedir o login ou limitar funcionalidades.
      </p>

      <h4>11. Comunicações pelo WhatsApp</h4>
      <p class="text-terms">
        O estabelecimento deve obter as autorizações exigidas para contatar seus
        clientes, respeitar pedidos de cancelamento e observar as políticas do
        WhatsApp Business e a legislação aplicável. O conteúdo das mensagens deve ser
        pertinente ao relacionamento entre o estabelecimento e o destinatário. O
        Centrallize não autoriza spam, listas adquiridas sem base legal ou comunicações
        enganosas.
      </p>

      <h4>12. Crianças e adolescentes</h4>
      <p class="text-terms">
        A plataforma é destinada ao uso profissional por pessoas autorizadas pelo
        estabelecimento. Caso o estabelecimento cadastre dados de crianças ou
        adolescentes, ele deverá observar o melhor interesse do titular e obter a
        autorização do responsável quando exigida pela legislação.
      </p>

      <h4>13. Atualizações desta política</h4>
      <p class="text-terms">
        Esta Política poderá ser atualizada para refletir mudanças legais, técnicas ou
        operacionais. A versão vigente será publicada nesta página com a data de
        atualização. Alterações relevantes poderão ser comunicadas pelos canais
        cadastrados ou dentro da plataforma.
      </p>

      <h4>14. Contato</h4>
      <p class="text-terms">
        Para dúvidas, solicitações de privacidade ou comunicação de incidentes, entre
        em contato pelo e-mail
        <a href="mailto:contato@sanvault.com.br">contato@sanvault.com.br</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
};
</script>

<style scoped>
.legal-document {
  max-width: 980px;
  margin: 0 auto;
  text-align: left;
}

.legal-document h1 {
  width: 100%;
  margin-bottom: 8px;
  text-align: center;
}

.legal-document h4 {
  margin-top: 28px;
}

.document-date {
  width: 100%;
  margin-bottom: 24px;
  text-align: center;
}

.text-terms {
  margin-bottom: 16px !important;
  line-height: 1.7;
}

.text-terms li + li {
  margin-top: 8px;
}
</style>
